module.exports = {
	"commitCount": 46,
	"commitMembers": [
		{
			"count": 41,
			"authorName": "airyland"
		},
		{
			"count": 4,
			"authorName": "万刚"
		},
		{
			"count": 1,
			"authorName": "Season"
		}
	],
	"commitUniqueCount": 3
};


//////////////////
// WEBPACK FOOTER
// ./zh-CN/components/x-address_git_metas.json
// module id = 3131
// module chunks = 18